(function () {
  function attach(scroller, host) {
    if (!scroller || !host) return;
    if (scroller.dataset.geSliderBar === '1') return;
    var max = scroller.scrollWidth - scroller.clientWidth;
    if (max <= 4) return;

    scroller.dataset.geSliderBar = '1';
    var bar = document.createElement('div');
    bar.className = 'ge-slider-bar';
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    thumb.className = 'ge-slider-bar__thumb';
    bar.appendChild(thumb);
    host.appendChild(bar);

    function update() {
      var overflow = scroller.scrollWidth - scroller.clientWidth;
      if (overflow <= 4) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;
      var ratio = scroller.clientWidth / scroller.scrollWidth;
      var thumbW = Math.min(0.45, Math.max(0.16, ratio));
      var travel = 1 - thumbW;
      var x = overflow > 0 ? (scroller.scrollLeft / overflow) * travel : 0;
      thumb.style.width = thumbW * 100 + '%';
      thumb.style.left = x * 100 + '%';
    }

    scroller.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Instagram feed: same progressive-fill line as the PDP 'Pairs well with' rail
     (.ge-product-rail-progress, fill = (1 + f*(n-1))/n), in the header row beside the title. */
  function attachFill(social, track) {
    if (!social || !track || track.dataset.geRailFill === '1') return;
    var cards = track.querySelectorAll('.instafeed-shoppable__card');
    if (cards.length < 2) return;
    track.dataset.geRailFill = '1';
    var progress = document.createElement('span');
    progress.className = 'ge-product-rail-progress ge-social__progress';
    progress.setAttribute('aria-hidden', 'true');
    progress.appendChild(document.createElement('span'));
    var card = social.querySelector('.ge-social__card') || social;
    var row = document.createElement('div');
    row.className = 'ge-social__head';
    var handle = card.querySelector(':scope > .ge-social__handle');
    card.insertBefore(row, card.firstChild);
    if (handle) row.appendChild(handle);
    row.appendChild(progress);
    function update() {
      var n = track.querySelectorAll('.instafeed-shoppable__card').length || 1;
      var max = track.scrollWidth - track.clientWidth;
      var f = max > 1 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 1;
      progress.firstChild.style.width = (max > 1 ? (1 + f * (n - 1)) / n * 100 : 100) + '%';
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    if (typeof ResizeObserver === 'function') new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update);
    update();
  }

  function scan() {
    document.querySelectorAll('.product-image-container').forEach(function (host) {
      attach(host.querySelector('.product-images'), host);
    });
    document.querySelectorAll('.ge-social, #insta-feed, .instafeed-shopify').forEach(function (root) {
      var social = root.classList && root.classList.contains('ge-social') ? root : root.closest('.ge-social');
      if (!social) return;
      attachFill(social, social.querySelector('.instafeed-shoppable__track'));
    });
  }

  function boot() {
    scan();
    var observer = new MutationObserver(scan);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', scan);
    [200, 600, 1200, 2400].forEach(function (ms) {
      window.setTimeout(scan, ms);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
